import HowToOrderMobile from './HowToOrderMobile'

export default HowToOrderMobile
